export interface TraceRef {
  trace_id: string;
  timestamp?: string;
}

// Matches agentSms/Call.tsx: no prefix configured means no link, never a half-built URL.
const traceUrl = (
  prefix: string | undefined,
  traceId: string,
): string | null => (prefix ? `${prefix}/${traceId}` : null);

export const phoenixTraceUrl = (traceId: string): string | null =>
  traceUrl(process.env.REACT_APP_LEAD_ENGAGEMENT_TRACE_URL_PREFIX, traceId);

// Cadence prompts run under their own Phoenix project, so a message-trace URL would
// point the same id at the wrong project.
export const cadenceTraceUrl = (traceId: string): string | null =>
  traceUrl(process.env.REACT_APP_CADENCE_TRACE_URL_PREFIX, traceId);
